export const TAG_VS_COLORS = {
  blue: {
    bgColor: '#D4F0FF',
    fontColor: '#4771DD',
  },
  yellow: {
    bgColor: '#FCF8EB',
    fontColor: '#A38740',
  },
  green: {
    bgColor: '#E9F9EF',
    fontColor: '#22C55E',
  },
  red: {
    bgColor: '#F7E4E3',
    fontColor: '#DD4E47',
  },
  gray: {
    bgColor: '#E7E7E7',
    fontColor: '#635F5F',
  },
  purple: {
    bgColor: 'rgba(239, 236, 253, 0.89)',
    fontColor: '#5340A3',
  },
};

export type COLORS = 'blue' | 'yellow' | 'gray' | 'green' | 'red' | 'purple';
